import { Injectable } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs';

export class ContPaginator<T> {

    get currentPage(): number {
        return this._currentPage;
    }

    set currentPage(value: number) {
        this._currentPage = value;
        this.refreshPage();
    }

    totalPages: number;
    list: Array<T>;
    pages$: Subject<Array<T>>;
    private _currentPage: number;
    entriesPerPage: number;

    constructor(entriesPerPage, currentPage = 1) {
        this.entriesPerPage = entriesPerPage;
        this._currentPage = currentPage;
        this.pages$ = new ReplaySubject();
    }

    refreshPage() {
        this.pages$.next(
            this.list.slice(
                (this.currentPage - 1) * this.entriesPerPage,
                this.currentPage * this.entriesPerPage
            )
        );
    }

    paginate(fullList: Array<T>): Observable<Array<T>> {

        this.list = fullList;
        this.totalPages = Math.max(1, Math.ceil(this.list.length / this.entriesPerPage));

        if (this.currentPage === null) {

            this.currentPage = 1;

        } else {

            if (this.currentPage <= this.totalPages) {
                this.refreshPage();
            } else {
                this.currentPage = this.totalPages;
            }
        }

        return this.pages$.asObservable();
    }

}

@Injectable()
export class PaginatorService {

    constructor() { }

    createPaginator<T>(entriesPerPage, currentPage = 1): ContPaginator<T> {

        return new ContPaginator<T>(entriesPerPage, currentPage);

    }

}
